import React from 'react';

import styles from './ChangeCoverageWarning.module.css';

import warningIcon from '../../../../assets/changeCoverage/plans/warning.svg';

export const ChangeCoverageWarning = ({ description, title }) => (
  <div className={styles.warning}>
    <img alt="" src={warningIcon} />

    <div>
      <h4>{title}</h4>

      <span>{description}</span>
    </div>
  </div>
);
